import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { I18NextPipe } from 'angular-i18next';
import { ToastService } from '@fullyops/shared/services/toast/toast.service';
import { ResourceType } from '@fullyops/data/quotas/quota';
import { PermissionType } from '@fullyops/legacy/ui/ui-shared/utils/crm-types';
import { UiAuthService } from '@fullyops/legacy/ui/ui-crm/ui-auth.service';

@Injectable()
export class QuotaExceededInterceptor implements HttpInterceptor {
  constructor(
    private toastService: ToastService,
    private i18nextPipe: I18NextPipe,
    private injector: Injector,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 409 && error.error?.error === 'QUOTA_EXCEEDED') {
          return this.handleQuotaExceeded(
            error.error.resourceType as ResourceType,
            error,
          );
        }
        return throwError(() => error);
      }),
    );
  }

  private handleQuotaExceeded(
    resourceType: ResourceType,
    error: HttpErrorResponse,
  ): Observable<never> {
    const resourceName = this.i18nextPipe.transform(
      `quotaResource.${resourceType}`,
    );
    const message = this.i18nextPipe.transform('quotaExceeded.mainMessage', {
      resource: resourceName,
    });

    const authService = this.injector.get(UiAuthService);
    const hasPermissions = authService.hasPermissionNoAsync([
      PermissionType.CAN_MANAGE_QUOTAS,
    ]);

    if (hasPermissions) {
      const linkLabel = this.i18nextPipe.transform('quotaExceeded.viewQuota');
      this.toastService.showErrorMessageWithLink(
        message,
        linkLabel,
        '/my-subscription/quotas',
      );
    } else {
      this.toastService.showErrorMessage(message);
    }
    return throwError(() => error);
  }
}
